import { JOB_BUILDER_SECTIONS, type JobBuilderSection, type ModuleKey, type ModuleState } from '@nest-recruit/shared';
import { useModules } from '../../../lib/modules';

/** R1 (§L34): the JOB-13 sections that belong to a switchable module. ADR 0062 §3: Screening criteria is one of them, off by default. */
const SECTION_MODULES: Partial<Record<JobBuilderSection, ModuleKey>> = {
  criteria: 'screening_criteria',
  form: 'career_site',
  offer: 'offers',
  post: 'job_image',
};

/** JOB-13's sections with switched-off modules left out, so the list closes up (QoL §13). */
export function builderSectionsFor(modules: ModuleState): readonly JobBuilderSection[] {
  return JOB_BUILDER_SECTIONS.filter((section) => {
    const owner = SECTION_MODULES[section];
    return owner === undefined || modules[owner];
  });
}

export function useBuilderSections(): readonly JobBuilderSection[] {
  return builderSectionsFor(useModules());
}
